import { LoadingStates } from '@pb/utils'

import { BankTransferState } from '../types'

const initialState: BankTransferState = {
  bankInfos: null,
  selectedBankId: null,
  initStatus: LoadingStates.NotLoaded,
  showError: false,
  showBankSelectionPopup: false,
}

export default initialState
